import { TranslateService } from '@ngx-translate/core';

export class MetaPropertySchema {
	constructor(translate: TranslateService) {
		this.translate = translate;
		if (!this.display) {
			this.display = {
				patternErrorMessage: {},
				placeholder: {},
				type: 'text',
				inputMask: null,
				tooltipMessage: {},
				multiple: false
			}
		}
	}
	id: number;
	requiredOnForm: boolean;
	name: string;
	pattern: string;
	usedOnForm: boolean;
	binary: boolean;
	display: {
		patternErrorMessage: {},
		placeholder: {},
		type: string,
		inputMask: string,
		tooltipMessage: {},
		multiple: boolean
	};
	getNormalizedForSave() {
		return {
			id: this.id,
			requiredOnForm: this.requiredOnForm,
			name: this.name,
			pattern: this.pattern,
			usedOnForm: this.usedOnForm,
			binary: (this.display && this.display.type === 'file') || this.binary,
			display: JSON.stringify(this.display)
		}
	};
	translate: TranslateService;
	get label(): string {
		let label = this.display && this.display.placeholder && this.display.placeholder[this.translate.currentLang];
		if (this.name === "password") {
			return this.translate.instant("users.password");
		}
		if (this.name === "name") {
			return this.translate.instant("users.lastname");
		}
		return label;
	};
}
